export function PadToNDigits(string, n , character){
    character = character || '0';
    string = string + '';
    return String(string).padStart(n, character);
}